import { fetchWithAuth } from "./fetchWithAuth";

const API_BASE = process.env.REACT_APP_API_BASE;

async function request(path, options = {}) {
  const response = await fetchWithAuth(`${API_BASE}${path}`, options);
  if (!response) {
    throw new Error("Неуспешна автентикација.");
  }

  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const data = await response.json();
      message = data?.detail || data?.message || message;
    } catch {
      // Keep fallback message when body is not JSON.
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export function getAdminUsers() {
  return request("/admin/users", { method: "GET" });
}

export function getAdminWeddings() {
  return request("/admin/weddings", { method: "GET" });
}

export function getAdminUsageOverview() {
  return request("/admin/usage-overview", { method: "GET" });
}

export function getTemplates() {
  return request("/templates", { method: "GET" });
}

export function getTemplateById(templateId) {
  return request(`/templates/${templateId}`, { method: "GET" });
}

export function createTemplate(payload) {
  return request("/admin/templates", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateTemplate(templateId, payload) {
  return request(`/admin/templates/${templateId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteTemplate(templateId) {
  return request(`/admin/templates/${templateId}`, { method: "DELETE" });
}

export function getAdminUserFromEmail(userEmail) {
  return request(`/admin/user-from-email/${encodeURIComponent(userEmail)}`, {
    method: "GET",
  });
}

export function getAdminSponsoredCampaigns() {
  return request("/admin/sponsored-campaigns", { method: "GET" });
}

export function getAdminSponsoredCampaignById(postId) {
  return request(`/admin/sponsored-campaigns/${postId}`, { method: "GET" });
}

export function createAdminSponsoredCampaign(payload) {
  return request("/admin/sponsored-campaigns", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAdminSponsoredCampaign(postId, payload) {
  return request(`/admin/sponsored-campaigns/${postId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteAdminSponsoredCampaign(postId) {
  return request(`/admin/sponsored-campaigns/${postId}`, {
    method: "DELETE",
  });
}

export function uploadAdminSponsoredCampaignImage(postId, file) {
  if (!postId || !file) {
    throw new Error("Недостасува кампања или датотека за прикачување.");
  }

  const formData = new FormData();
  formData.append("file", file);

  return request(`/admin/sponsored-campaigns/${postId}/image`, {
    method: "POST",
    body: formData,
  });
}
